import React from 'react'
import { Badge, Text, tokens } from '@fluentui/react-components'
import './CareerTimeline.css'
import { careerTimelineContent } from './content'
import ScrollReveal from '../ScrollReveal'

export const CareerTimeline: React.FC = () => {
	return (
		<div className="career-timeline">
			{careerTimelineContent.milestones.map((milestone, index) => (
				<ScrollReveal key={milestone.year + milestone.title} delay={Math.min(index * 60, 240)}>
					<div className="career-timeline-item">
						<div className="career-timeline-marker">
							<span className="career-timeline-dot" />
						</div>
						<div className="career-timeline-content">
							<div className="career-timeline-year">{milestone.year}</div>
							<Text as="h3" size={500} weight="semibold" block className="career-timeline-title">
								{milestone.title}
							</Text>
							<Text size={300} block style={{ color: tokens.colorNeutralForeground2 }}>
								{milestone.description}
							</Text>
							<div className="career-timeline-tags">
								{milestone.tags.map(tag => (
									<Badge key={tag} color="informative" appearance="outline" size="small">
										{tag}
									</Badge>
								))}
							</div>
						</div>
					</div>
				</ScrollReveal>
			))}
		</div>
	)
}

export default CareerTimeline
